<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">序号</label>
            <span class="weui-form-preview__value">{{initData.pd_pdno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <span class="weui-form-preview__value">{{initData.pi_inoutno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务类型</label>
            <span class="weui-form-preview__value">{{pi_class(initData.pi_class)}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">往来单位</label>
            <span class="weui-form-preview__value">{{initData.bizname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库数量</label>
            <span class="weui-form-preview__value">{{initData.pd_inqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出库数量</label>
            <span class="weui-form-preview__value">{{initData.pd_outqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结存数量</label>
            <span class="weui-form-preview__value">{{initData.pd_endqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库</label>
            <span class="weui-form-preview__value">{{initData.wh_description}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成本金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_total}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结存金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_endamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">关联单号</label>
            <span class="weui-form-preview__value">{{initData.pd_ordercode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">归属业务员</label>
            <span class="weui-form-preview__value">{{initData.pd_sellername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">转入业务员</label>
            <span class="weui-form-preview__value">{{initData.pi_inseller}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">还货要求</label>
            <span class="weui-form-preview__value">{{initData.pi_repaygoods}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{initData.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{initData.pi_auditman}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{initData.pd_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  },
  methods: {
    pi_class(type) {
      type = type.toUpperCase()
      if(type=="PURCIN"){
          type = '采购入库';
      }else if(type=="PURCOUT"){
          type = '采购退货';
      }else if(type=="SALEOUT" ){
          type = '销售出货';
      }else if(type=="SALERETURN"){
          type = '销售退货';
      }else if(type=="OTHERIN"){
          type = '其它入库';
      }else if(type=="OTHEROUT" ){
          type = '其它出库';
      }else if(type=="RESERVEINITIALIZE"){
          type = '库存初始化';
      }else if(type=="STOCKPROFIT"){
          type = '盘盈入库';
      }else if(type=="STOCKLOSS"){
          type = '盘亏出库';
      }else if(type=="MOtypeEOUT"){
          type = '移仓单';
      }else if(type=="MOVEIN"){
          type = '移仓单';
      }else if(type=="MAKEPICK"){
          type = '生产领料';
      }else if(type=="MAKERETURN"){
          type = '生产退料';
      }else if(type=="MAKEIN"){
          type = '完工入库';
      }else if(type=="OSMAKEPICK"){
          type = '外协领料';
      }else if(type=="OSMAKERETURN"){
          type = '外协退料';
      }else if(type=="OSMAKEIN"){
          type = '外协入库';
      }else if(type=="OSMAKEINBACK"){
          type = '外协退货';
      }else if(type=="MAKEDISMANTLE"){
          type = '工单拆件';
      }else if(type=="OSMAKEDISMANTLE"){
          type = '外协拆件';
      } 
      return type;
    }
  }
};
</script>